import React from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import SEO from 'src/components/seo/index'
import Header from 'src/components/header/setting'
import Link from 'src/components/link/index'
import Keyvisual from 'src/components/keyvisual/index'
import Card from 'src/components/card/index'
import Image from 'src/components/image/dynamic'
import Movie from 'src/components/movie/button'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import * as styles from './index.module.scss'



const IndexPage = () => {

	const data = useStaticQuery(graphql`
        query {
            arrangement: allWpArrangement(limit: 1) {
                nodes {
                    custom {
                        line1 {
							__typename
							... on WpArrangement_Custom_Line1_Article {
								article {
									... on WpArticle {
										custom {
											slug, type, url, title, lead, datetime
											visualPc { ...Image1920 }
											visualSp { ...Image1920 }
										}
										tags: articleTags {
											nodes { name }
										}
									}
								}
							}
                            ... on WpArrangement_Custom_Line1_Video {
								youtubeVideoId
								thumbnailPc { ...Image1920 }
								thumbnailSp { ...Image1920 }
							}
                        }
                        line2 {
							... on WpArrangement_Custom_Line2_Article {
								article {
									... on WpArticle {
										custom {
											slug, type, url, title, lead, datetime
											thumbnailPc { ...Image660 }
											thumbnailSp { ...Image660 }
										}
										tags: articleTags {
											nodes { name }
										}
									}
								}
							}
                        }
                        line3 {
							... on WpArrangement_Custom_Line3_Article {
								article {
									... on WpArticle {
										custom {
											slug, type, url, title, lead, datetime
											thumbnailPc { ...Image660 }
											thumbnailSp { ...Image660 }
										}
										tags: articleTags {
											nodes { name }
										}
									}
								}
							}
                        }
                    }
                }
            }
        }
    `)

	const line1 = data.arrangement.nodes[0]?.custom.line1
	const line2 = data.arrangement.nodes[0]?.custom.line2[0]
	const line3 = data.arrangement.nodes[0]?.custom.line3[0]


	return (
		<div>
			<SEO title={``} />
			<Header color={`white`} />

			<div className={styles.mainVisual}>
				<Keyvisual />
			</div>

			<div className={styles.list}>

				{line1 && line1[0].__typename === 'WpArrangement_Custom_Line1_Article' && (
					<div className={styles.line1}>
						<Card data={line1[0].article[0]} size={1} />
					</div>
				)}

				{line1 && line1[0].__typename === 'WpArrangement_Custom_Line1_Video' && (
					<SlideinWrap className={styles.line1}>
						<SlideinItem>
							<Movie className={styles.movie} videoID={line1[0].youtubeVideoId}>
								<Image imagePC={line1[0].thumbnailPc} imageSP={line1[0].thumbnailSp} />
								<div className={styles.play}>
									<span>play</span>
								</div>
							</Movie>
						</SlideinItem>
					</SlideinWrap>
				)}

				{line2 && (
					<ul className={styles.line2}>
						<li><Card data={line2.article[0]} size={2} /></li>
						<li><Card data={line2.article[1]} size={2} /></li>
					</ul>
				)}

				{line3 && (
					<ul className={styles.line3}>
						<li><Card data={line3.article[0]} size={3} /></li>
						<li><Card data={line3.article[1]} size={3} /></li>
						<li><Card data={line3.article[2]} size={3} /></li>
					</ul>
				)}
			</div>
			<SlideinWrap className={styles.more}>
				<SlideinItem>
					<Link to="/article/">MORE</Link>
				</SlideinItem>
			</SlideinWrap>
		</div>
	)
}

export default IndexPage
